import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { stepContent, header, singleInput, phoneCheck } from "../style";
import InputForm from "../../../../../shared/atoms/InputForm";

import {
	patternOnlyNumbers,
	phoneNumberMask
} from "../../../../../shared/create-offer/utils/masks";

import { useNewOfferMobile } from "../../context";
import { useNewOffer } from "../../../../context/new-offer";
import InfoTwoFactor from "./infosSeeMore/infoTwoFactor";
import { GOL_TWO_FACTOR_MESSAGE } from "../../../../../../js/shared/constants";

// Debounce function
let timerId;
let fnWaiting;
const debounced = (fn, delay = 250) => {
	if (timerId) clearTimeout(timerId);
	if (!fn && fnWaiting) fnWaiting();
	fnWaiting = fn;
	if (!fn) return;
	timerId = setTimeout(fn, delay);
};

const PhoneTwoFactor = ({ onChangeLoyalty }) => {
	const { currentProgram: fidelityProgram, loyaltyData } = useNewOffer();
	const { setStepError } = useNewOfferMobile();

	const [state, setState] = useState({
		phone: loyaltyData.data.phone || "",
		hasError: false
	});

	const [debouncing, setDebouncing] = useState(false);

	useEffect(() => {
		const phone = loyaltyData.data.phone
			? loyaltyData.data.phone
					.match(patternOnlyNumbers)
					.join("")
					.toString()
			: "";
		const hasError = phone !== undefined && (phone.length !== 11 || phone[2] !== "9");
		setState({
			...state,
			phone: phone,
			hasError: !debouncing && hasError
		});

		setStepError(!phone || hasError || debouncing);
	}, [loyaltyData.data, debouncing]);

	const onChangePhone = value => {
		let phone = value.match(patternOnlyNumbers)
			? value
					.match(patternOnlyNumbers)
					.join("")
					.toString()
			: "";
		setState({
			hasError: false,
			phone: phone
		});
		setDebouncing(true);
		debounced(() => setDebouncing(false), 1000);
		onChangeLoyalty({ phone: value });
	};

	return (
		<div
			className={css`
				${stepContent};
			`}
		>
			<strong
				className={css`
					${header};
				`}
			>
				Dados da {fidelityProgram.fidelityName}
			</strong>

			<div
				className={css`
					${singleInput};
				`}
			>
				<InputForm
					name="phone"
					id="phone"
					type="tel"
					value={state.phone}
					onChange={ev => {
						onChangePhone(ev.target.value);
					}}
					onBlur={() => debounced(null)}
					placeholder=""
					mask={phoneNumberMask}
					label="Número de telefone"
					errorMessage="Número de celular inválido."
					hasError={state.phone?.length > 0 && state.hasError}
					data-action="login-offer-phone"
				/>
				<InfoTwoFactor mainMessage={GOL_TWO_FACTOR_MESSAGE} />
			</div>
		</div>
	);
};

export default PhoneTwoFactor;
